<ng-container *t="let t">
    <div class="inside-container">
        <div fxLayout="row">
            <div fxFlex="70" fxLayoutAlign="start center">
                <h3 class="tab-header" i18n="@@6480898732057847756" t="6480898732057847756">Tax Details</h3>
                <a target="_blank" [href]="helpUrl">
                    <tsl-icon size="small" class="header-help-icon" tooltip="Training" i18n-tooltip="@@4013060476269413412" #helpButton tslTooltip="{{ t('4013060476269413412', helpButton) }}">help</tsl-icon>
                </a>
            </div>
        </div>
        <div fxLayout="row">
            <p *ngIf="isDataUnderReview">
                <tsl-alert status="warning" class="spacing">
                    <h4 i18n="@@DataUnderReview" t="DataUnderReview">Data Changes Under Tesla Review</h4>
                    <br/>
                    <span i18n="@@DataUnderReviewDescription" t="DataUnderReviewDescription">
                        Submitted data changes are currently under review by Tesla. The ability to self-service in the Tesla Supplier Profile may be limited or restricted while your submission is being reviewed. Other aspects of the Supplier Relationship Management Portal should still be available to you based on your user access.
                    </span>
                </tsl-alert>
            </p>
        </div>
        <div fxLayout="row" fxLayoutGap="5px">
            <p>
                <span i18n="@@6660756004355291952" t="6660756004355291952"
                    >The Supplier Tax Details are available to users to manage their organizations Tax accounts. Supplier
                    Profile data changes, will go to Tesla for review and approval for validation purposes.</span
                >
                <br />
                <b i18n="@@99e6df02a2f598db23f2cfbe7201e16e082223cd" t="99e6df02a2f598db23f2cfbe7201e16e082223cd"
                    >Please Note:</b
                >
                <span i18n="@@8c35221405bb87318bfeae83562cd3b31ad812fe" t="8c35221405bb87318bfeae83562cd3b31ad812fe"
                    >Only your organizations Primary Contact and Finance Lead can make changes. You will receive emails in
                    regards to rejections or approval of changes.</span
                >
            </p>
        </div>
        <br />
        <app-tax-grid #taxgrid></app-tax-grid>
    </div>
</ng-container>
